<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Roster Records
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-row class="py-2 justify-items-between">
                  <!-- Search -->
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    />
                  </v-col>

                  <!-- Export Buttons -->
                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                        >
                          CSV
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                        >
                          EXCEL
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                        >
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <!-- Add Button -->
                  <v-col md="4" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo()"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Add Roster
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <!-- Roster Data Table -->
                <v-data-table
                  :headers="headers"
                  :items="getRosterList"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >

                <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                      v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                      color="yellow-darken-3"
                      size="small"
                    >
                      Wating for {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                      color="green"
                      size="small"
                    >
                      Approved By {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                      color="red"
                      size="small"
                    >
                      Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else
                      color="green"
                      size="small"
                    >
                      {{ item.approval_status }}
                    </v-chip>
                  </template>

                  <!-- Status -->
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                    >
                      Active
                    </v-chip>
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                    >
                      Inactive
                    </v-chip>
                  </template>

                  <!-- Actions -->
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-file-document-outline"
                      size="small"
                      variant="text"
                      color="blue"
                      @click="viewRoster(item)"
                      v-if="$updateAccess($route.fullPath)"
                    />
                    <v-btn
                      icon="mdi-pencil"
                      size="small"
                      variant="text"
                      color="blue"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath)"
                    />
                  </template>

                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  data: () => ({
    itemsPerPage: "-1",
    panel: [0],
    search: "",
    loading: false,
    headers: [
      { title: "#SL", align: "center", key: "id", sortable: false, width: "50px" },
      { title: "From Date", key: "from_date", align: "left", sortable: false },
      { title: "To Day", key: "to_date", align: "left", sortable: false },
      { title: "Code", key: "code", align: "left", sortable: false },
      { title: "Approval Status", key: "approval_status_display", align: "left", sortable: false },
      { title: "Status", key: "status", align: "left", sortable: false },
      { title: "Actions", key: "actions", align: "center", sortable: false },
    ],
  }),

  computed: {
    getRosterList() {
      return this.$store.getters.getRosterList;
    },
  },

  created() {
    // if (this.$store.getters.getRosterList.length === 0) {
      this.loading = true;
      this.$store.dispatch("getRosterList").finally(() => {
        this.loading = false;
      });
    // }
  },

  methods: {
    goTo() {
      this.$router.push({ name : 'employee-roster-add' }).catch(() => {});
    },

    editItem(item) {
      this.$router.push({ name: "employee-roster-add", params: { id: item.id } });
    },
    viewRoster(item){
        this.$router.push({ name : 'employee-roster-view', params: { id: item.id } }).catch(() => {});
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = ["#SL", "Code", "Department", "Shift", "From Date", "To Date", "Status"];
      const rows = this.getRosterList.map(item => [
        serialNumber++,
        item.code,
        item.department_id,
        item.shift_id,
        item.from_date,
        item.to_date,
        item.status == 1 ? "Active" : "Inactive",
      ]);
      this.$exportTableToPDF(columns, rows, "Roster List", "roster_list_" + this.$fileDate());
    },

    exportToExcel() {
      let data = [["#SL", "Code", "Department", "Shift", "From Date", "To Date", "Status"]];
      let serialNumber = 1;
      this.getRosterList.forEach(item => {
        data.push([
          serialNumber++,
          item.code,
          item.department_id,
          item.shift_id,
          item.from_date,
          item.to_date,
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });
      this.$exportTableToExcel(data, "roster_list_" + this.$fileDate());
    },

    exportToCSV() {
      let data = [["#SL", "Code", "Department", "Shift", "From Date", "To Date", "Status"]];
      let serialNumber = 1;
      this.getRosterList.forEach(item => {
        data.push([
          serialNumber++,
          item.code,
          item.department_id,
          item.shift_id,
          item.from_date,
          item.to_date,
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });
      this.$exportTableToCSV(data, "roster_list_" + this.$fileDate());
    },
    getDayName(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString("en-US", { weekday: "long" }); // Monday, Tuesday ...
    },
  },
};
</script>

<style scoped>
</style>
